import React from 'react';
import {
  Container, Tab, Row, Col, Nav,
} from 'react-bootstrap';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { Template } from '../template/index';
import { CreateComponent } from './CreateComponent';
import { ListComponents } from './ListComponents';
import { ImageComponent } from './ImageComponent';

export function Components () {
  const history = useHistory();
  function handleGoBack () {
    history.push('/');
  }
  return (
    <Template>

      <Container className="main-updates">
        <div className="goBack">
          <FontAwesomeIcon icon={faArrowLeft} title="Voltar" size="lg" onClick={handleGoBack} />
          <h2>Gerenciar Componentes</h2>
        </div>
        <hr />
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row>
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">Componentes</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Cadastrar Componentes</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Mudar thumbnail do componente</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <ListComponents />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <CreateComponent />
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <ImageComponent />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </Template>
  );
}
